import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Container, Flex, Text, Theme } from "@radix-ui/themes";
import { Helmet } from "react-helmet-async";
import { useLDClient } from "@launchdarkly/react-sdk";
import { IrisCtaLink } from "../../components/IrisCtaLink";
import { TitleBlock } from "../TitleBlock";
import { siteUrl } from "../../lib/site";

export function WelcomePage() {
  // useLDClient throws during prerendering when LDProvider context doesn't exist
  const ldClient = typeof window !== "undefined" ? useLDClient() : undefined;
  const [searchParams] = useSearchParams();

  const imessageRedirect = searchParams.get("imessage_redirect");
  const smsRedirect = searchParams.get("sms_redirect");

  // Build redirect URL if params are present (URL encode the value)
  const redirectUrl = imessageRedirect
    ? `imessage://${encodeURIComponent(imessageRedirect)}?body=${encodeURIComponent("Ready to continue")}`
    : smsRedirect
      ? `sms://${encodeURIComponent(smsRedirect)}?body=${encodeURIComponent("Ready to continue")}`
      : null;

  // Auto-redirect when redirect URL is present
  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <Theme
      appearance="light"
      accentColor="gray"
      grayColor="gray"
      radius="large"
    >
      <Box
        style={{
          backgroundColor: "#fff",
          backgroundImage: "none",
          minHeight: "100vh",
        }}
      >
        <Container size="4" className="route-page">
          <Helmet>
            <title>Welcome | Iris</title>
            <meta
              name="description"
              content="Access unlocked. Start your journey with Iris."
            />
            <link rel="canonical" href={siteUrl("/welcome/")} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={siteUrl("/welcome/")} />
            <meta property="og:title" content="Welcome | Iris" />
            <meta
              property="og:description"
              content="Access unlocked. Start your journey with Iris."
            />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content="Welcome | Iris" />
            <meta
              name="twitter:description"
              content="Access unlocked. Start your journey with Iris."
            />
          </Helmet>
          <Flex direction="column" gap="6" align="center">
            <TitleBlock
              title="Access Unlocked!"
              subtitle="Start your journey with Iris"
              style={{ maxWidth: 840, padding: "25px 16px 0" }}
              innerStyle={{
                minHeight: "55vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              headingStyle={{
                fontSize: 27,
                fontWeight: 400,
                lineHeight: "26px",
              }}
            >
              <IrisCtaLink
                label="Get Iris"
                ldClient={ldClient ?? undefined}
                overrideHref={redirectUrl ?? undefined}
              />
            </TitleBlock>
            <Text align="center" size="2">
              Have questions? Contact our friendly support team at
              support@irischat.ai
            </Text>
          </Flex>
        </Container>
      </Box>
    </Theme>
  );
}
